import { faces as f } from "@/assets/faces";
import type { FC, Fragment } from "react";

interface PainFaceIconProps {
	value: number;
}

export const PainFaceIcon: FC<PainFaceIconProps> = ({ value }) => {
	const getFaceIcon = () => {
		switch (value) {
			case 0:
				return <f.Zero />;
			case 1:
				return <f.One />;
			case 2:
				return <f.Two />;
			case 3:
				return <f.Three />;
			case 4:
				return <f.Four />;
			case 5:
				return <f.Five />;
			case 6:
				return <f.Six />;
			case 7:
				return <f.Seven />;
			case 8:
				return <f.Eight />;
			case 9:
				return <f.Nine />;
			case 10:
				return <f.Ten />;
			default:
				return <f.Five />;
		}
	};

	return <>{getFaceIcon()}</>;
};

export default PainFaceIcon;
